import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes, last-wins on conflicts. Every primitive in `components/ui` builds its
 * class list through this, which is what lets a caller override a variant's defaults from the
 * outside without `!important`.
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
